import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);
/* eslint-disable */
const routes = [
  {
    path: "/login",
    name: "Login",
    meta: { layout: "blank" },
    component: () => import("../pages/AuthLogin"),
  },
  {
    path: "/",
    name: "Members",
    beforeEnter: protectedRoutes,
    component: () => import("../pages/Members"),
  },
  {
    path: "/members/:id",
    name: "Member Details",
    beforeEnter: protectedRoutes,
    component: () => import("../pages/SingleMemberDetails"),
  },
  {
    path: "/costs",
    name: "Cost Criteria",
    beforeEnter: protectedRoutes,
    component: () => import("../pages/Cost"),
  },
  {
    path: "/costs/:id",
    name: "Cost Details",
    beforeEnter: protectedRoutes,
    component: () => import("../pages/SingleCostDetails"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  document.title = `${process.env.VUE_APP_TITLE} - ${to.name}`;
  next();
});

// code to check authentication of the users

function protectedRoutes(to, from, next) {
  if (!store.state.auth.isAuthenticated) {
    next({ name: "Login" });
  } else {
    next();
  }
}

export default router;
